import { Share } from "./components/ShareButton/Share";
import styles from "./Tools.module.scss";
import { StoreStock } from "../__shared__/StoreStock/StoreStock";

type Props = {
  /**
   * A boolean indicating whether the product is active.
   */
  isActiveProduct: boolean;
  /**
   * A string representing the title of the product.
   */
  title: string;
  /**
   * A boolean indicating whether the product is a future release.
   */
  isFutureRelease: boolean;
  /**
   * A boolean indicating whether the product is pre-orderable.
   */
  isPreOrderable: boolean;
  /**
   * A string representing the display code of the product.
   */
  displayCode: string;
  /**
   * A string representing the SKU ID of the product.
   */
  skuId: string;
  /**
   * An array of strings representing the buttons. It can also be undefined.
   */
  buttons: Array<string> | undefined;
  /**
   * A string representing the share URL of the product.
   */
  shareUrl: string;
  /**
   * A string representing the share image of the product.
   */
  shareImage: string;
  /**
   * A boolean indicating whether the customer has selected a specific variant. For single variant products, this is implicit and always true.
   */
  isVariantSelected: boolean;
  /**
   * A string representing the store stock script URL.
   */
  storeStockScriptUrl: string;
  /**
   * A string representing the URL for the store stock modal information api
   */
  storeStockModalApiUrl: string;
  /**
   * A string representing the base URL of the stock API.
   */
  stockApiBaseUrl: string;
  /**
   * A string representing the key of the online stock API.
   */
  stockApiKey: string;
  /**
   * A string representing the key of the store stock API.
   */
  storeStockApiKey: string;
  /**
   * A boolean indicating whether the product is store stock only
   */
  isStoreStockOnly: boolean;
};

export const ToolsUI = ({
  isActiveProduct,
  title,
  isFutureRelease,
  isPreOrderable,
  displayCode,
  skuId,
  buttons = ["share", "in-store-stock"],
  shareUrl,
  shareImage,
  isVariantSelected,
  storeStockScriptUrl,
  stockApiBaseUrl,
  stockApiKey,
  storeStockApiKey,
  isStoreStockOnly,
  storeStockModalApiUrl,
}: Props) => {
  // store stock button in tools should be hidden for inStoreOnly products
  // because the other check in store stock button is rendered by AddToBasket
  const showStoreStock = !isStoreStockOnly;

  /**
   * product has all variant marked as inStoreOnly
   *
   *
   */

  return (
    <div>
      <div className={styles.container}>
        {buttons.map((button) => {
          switch (button) {
            case "share":
              return (
                <Share
                  shareUrl={shareUrl}
                  title={title}
                  shareImage={shareImage}
                  isActiveProduct={isActiveProduct}
                  key={button}
                  isVariantSelected={isVariantSelected}
                />
              );
            case "in-store-stock":
              return (
                showStoreStock && (
                  <StoreStock
                    key={button}
                    title={title}
                    displayCode={displayCode}
                    skuId={skuId}
                    isFutureRelease={isFutureRelease}
                    isPreOrderable={isPreOrderable}
                    usePrimaryButton={false}
                    storeStockScriptUrl={storeStockScriptUrl}
                    stockApiBaseUrl={stockApiBaseUrl}
                    stockApiKey={stockApiKey}
                    isVariantSelected={isVariantSelected}
                    storeStockModalApiUrl={storeStockModalApiUrl}
                    storeStockApiKey={storeStockApiKey}
                  />
                )
              );

            default:
              return null;
          }
        })}
      </div>
      {showStoreStock && (
        <div
          id="store-stock-error-wrapper"
          data-testid="product:tools:store-stock:error"
          className={styles.storeStockErrorWrapper}
        />
      )}
    </div>
  );
};
